import { useState } from "react";
import { useDispatch } from "react-redux";

import { useNavigation } from "utils/navigate";
import { fetchUserDetails } from "Layout/slice/thunk";
import { PreviousButton } from "../../../Components/SignupContainer.styles";
import { Loader } from "components/Loader";
import { TaxW9Agreement } from "shared/SurmountAccount/TaxW9Agreement/index";
import { SignAgreement } from "shared/SurmountAccount/SignAgreement/index";
import {
  SignupFlowFooter,
  SignupFlowContent,
  SignupFlowWrapperContainer,
} from "../../../Components/SignupFlowWrapper.styles";
import { toast } from "Layout/slice";
import { useMutation } from "hooks/useMutation";
import {
  updateSignAgreement,
  createAlpacaUser,
} from "features/SurmountAccount/service";
import {
  FooterRightWrapper,
  ContinueButtonStyled,
  TaxCardWrapper,
} from "./TaxW9Agreement.styles";
import { parseErrorMessage } from "utils/index";

const SurmountAccountTaxW9Agreement = () => {
  const { navigateToSignupIntroQuestions, navigateToSignupFundYourAccount } =
    useNavigation();
  const dispatch = useDispatch();

  const [agreementValues, setAgreementValues] = useState({
    agree: false,
    account_agreement: false,
    customer_agreement: false,
  });

  const areAllAgreementsAccepted =
    agreementValues.agree &&
    agreementValues.account_agreement &&
    agreementValues.customer_agreement;

  const { mutate: submitAgreement, isLoading: isSubmitting } = useMutation({
    mutationFn: updateSignAgreement,
    onSuccess: async () => {
      try {
        // Create Alpaca user after agreement is signed
        await createAlpacaUser();
        // Refresh user details to get updated account status
        dispatch(fetchUserDetails());
        navigateToSignupFundYourAccount();
      } catch (error) {
        // Show error message from backend
        dispatch(
          toast({
            type: "error",
            body: parseErrorMessage(error),
          })
        );
        // Refresh user details and redirect to dashboard even if account already exists
        dispatch(fetchUserDetails());
      }
    },
  });

  const handleNext = () => {
    if (!areAllAgreementsAccepted) {
      dispatch(
        toast({
          type: "error",
          body: "Please accept all agreements to proceed.",
        })
      );
      return;
    }

    const payload = {
      margin_agreement: agreementValues.agree,
      account_agreement: agreementValues.account_agreement,
      customer_agreement: agreementValues.customer_agreement,
    };

    submitAgreement(payload);
  };

  return (
    <>
      <SignupFlowWrapperContainer>
        <SignupFlowContent>
          <div className="header">
            <h3>Take a moment to review your agreement</h3>
            <p>Please take a moment to review your agreements carefully</p>
          </div>
          <TaxCardWrapper>
            <TaxW9Agreement />

            <SignAgreement
              onAgreementChange={setAgreementValues}
              agreementValues={agreementValues}
            />
          </TaxCardWrapper>
        </SignupFlowContent>

        <SignupFlowFooter>
          <FooterRightWrapper>
            <PreviousButton onClick={navigateToSignupIntroQuestions}>
              Go back
            </PreviousButton>
            <ContinueButtonStyled
              maxWidth="173px"
              onClick={handleNext}
              disabled={isSubmitting || !areAllAgreementsAccepted}
            >
              {isSubmitting ? (
                <Loader className="on-btn" />
              ) : (
                "Submit application"
              )}
            </ContinueButtonStyled>
          </FooterRightWrapper>
        </SignupFlowFooter>
      </SignupFlowWrapperContainer>
    </>
  );
};

export default SurmountAccountTaxW9Agreement;
